import { NOTES_DEMO_CONTENT } from './notesDemoContent'
import { noteAt, withContent } from './notesRailDemoNoteUtils'

/** @type {import('../lib/types.js').NotesRailNoteWire[]} */
export const notesRailDemoRegularNotesA = [
  withContent({
    id: 'n-welcome',
    kind: 'note',
    title: 'Where your notes turn into action.',
    content: NOTES_DEMO_CONTENT.welcome,
    at: noteAt(0, 10, 30),
  }),
  withContent({
    id: 'n-regular-ideas',
    kind: 'note',
    title: 'Ideas for the home screen',
    authorName: 'Myman',
    content: NOTES_DEMO_CONTENT.ideas,
    at: noteAt(0, 14, 5),
  }),
  withContent({
    id: 'n-design-tokens',
    kind: 'note',
    title: 'Design tokens audit',
    authorName: 'Jordan Lee',
    content: NOTES_DEMO_CONTENT.designTokens,
    at: noteAt(1, 16, 20),
  }),
]
